export const IS_FIREFOX = navigator.userAgent.toLowerCase().includes('firefox');
export const FIREFOX_SCROLLBAR_OVERLAP_SIZE = 12;
